import { createReducer } from 'typesafe-actions';
import { DataFetchingState } from '../../dataFetching/generators';
import { unblockUserActions, UnblockUserActions } from './actions';

const defaultState = {
    isFetching: false,
    didInvalidate: false,
    error: null,
    identifier: '',
};

const unblockReducer = createReducer<DataFetchingState, UnblockUserActions>(defaultState)
    .handleAction(unblockUserActions.request, state => {
        return {
            ...state,
            isFetching: true,
        };
    })
    .handleAction(unblockUserActions.success, state => {
        return {
            ...state,
            isFetching: false,
            didInvalidate: false,
        };
    })
    .handleAction(unblockUserActions.failure, state => {
        return {
            ...state,
            isFetching: false,
            didInvalidate: true,
        };
    });

export default unblockReducer;
